export const crmEntity = (zoneName: string, html: string) => {
  try {
    const tag = html.match('<!--data-analytics-tag="(.+?)"-->');
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const { packageId, packageName } = JSON.parse(tag![1]) as {
      packageId: number;
      packageName: string;
    };
    return { packageId, packageName };
  } catch {
    // do nothing
  }
};
